import { type GModalBaseProps, ModalType } from '~/presentation/ui';

import { GModalConfirmType } from '~/presentation/common';
import { useGModalContext } from '~/presentation/ui';
import { Box } from '@shopify/polaris';
import { GModal } from '../GModal';

export interface GModalConfirmProps extends GModalBaseProps {
  children: React.ReactNode;
  type?: GModalConfirmType;
}

export const GModalConfirm = ({
  type = GModalConfirmType.DEFAULT,
  title,
  size,
  children,
  primaryAction,
  secondaryActions,
}: GModalConfirmProps) => {
  const { modalType, isOpen, isLoading, initialValues, onCloseModal } =
    useGModalContext<ModalType.CONFIRM>();
  const confirmType = initialValues?.type || GModalConfirmType.DEFAULT;

  if (modalType !== ModalType.CONFIRM) return;
  if (confirmType !== type) return;

  return (
    <GModal
      open={isOpen}
      onClose={onCloseModal}
      loading={isLoading}
      title={title}
      size={size ?? 'large'}
      primaryAction={{
        content: 'Confirm',
        ...primaryAction,
      }}
      secondaryActions={
        secondaryActions ?? [
          {
            content: 'Cancel',
            onAction: onCloseModal,
          },
        ]
      }
      noScroll
    >
      <Box padding={'400'}>{children}</Box>
    </GModal>
  );
};
